import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';

// REDUX
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistedStore } from './store';

import MainApp from './layouts/main-app';

ReactDOM.render(
  <Router>
    <Fragment>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistedStore}>
          <MainApp />
        </PersistGate>
      </Provider>
    </Fragment>
  </Router>,
  document.getElementById('root')
);
